export default __webpack_public_path__ + "static/media/spinner.a7d8d4b2.svg";